import { Address } from "./address";
import { Income } from "./income";
import {EmploymentIncome} from './employment-income';
import {CurrentIncomeItem} from "@data/schema/loan-appication/current-income-item";

export class Employment {
  sEmploymentType: string;
  sName: string;
  sPhone: string;
  sStartDate: Date;
  sPosition: string;
  sEmail: string;
  sTimeInLineOfWork: number;
  sAddress: Address;
  sFax: string;
  sSelfEmployedFlag: boolean;
  sIsPrimaryEmploymentFlag: boolean;
  sSpecialBorrowerEmployerRelationShipType: string;
  sHRName: string;
  sHRTitle: string;
  sEmployeeCode: string;
  sHREmail: string;
  sHRContact: string;
  sSalaryKey: string;
  sCurrentIncomeItems: CurrentIncomeItem[] = [];
  uiShow: boolean;
  uiArrow: string;
  uiExpanderText = "Expand";
  uiShowFlag : boolean;
  sCurrentEmploymentIncomeTypeDummy : number;
}
